export default __webpack_public_path__ + "static/media/sent-mail.bd44fef0.png";